// Shared helper for opting a single request out of every HTTP cache layer.
//
// The public read endpoints are deliberately cacheable so hundreds of audience
// phones don't stampede the API (Phase 0 / TODO 0.3):
//   GET /api/events/slug/:slug  -> public, max-age=5,  stale-while-revalidate=30
//   GET /api/votes/event/:id    -> public, max-age=2,  stale-while-revalidate=10
//
// `stale-while-revalidate` is honoured by browsers as well as CDNs, so a
// reconciliation fetch can legitimately be answered from cache with data that
// is tens of seconds old — which is exactly what makes an admin action look
// like it took "a whole minute" to reach a display. Operator-facing,
// single-client surfaces (the LED wall) should therefore bypass caching; the
// shared audience paths must not.

/**
 * Build the axios request config that forces a fresh origin response.
 *
 * Implemented purely as a unique query parameter, deliberately NOT as a
 * `Cache-Control: no-cache` request header: that header is not CORS-safelisted,
 * so it would add a preflight OPTIONS round trip to every reconciliation
 * request and — since the API's `Access-Control-Allow-Headers` does not list
 * it — fail outright cross-origin. A unique query string also guarantees a
 * miss at every layer (browser cache, CDN), which a request header does not:
 * intermediaries commonly ignore or strip it, and these endpoints carry no
 * ETag to revalidate against.
 *
 * @param {boolean} [enabled] When falsy, returns baseConfig untouched so
 *   callers keep the cacheable default behaviour.
 * @param {object} [baseConfig] Extra axios config to merge (e.g. an
 *   AbortController signal).
 * @returns {object|undefined}
 */
export function httpCacheBypass(enabled, baseConfig) {
  if (!enabled) {
    return baseConfig;
  }
  return {
    ...baseConfig,
    params: { ...baseConfig?.params, _fresh: Date.now() }
  };
}
